// src/config.js — PagosCafé web client build config
// WARNING: internal settlement mesh config. Do NOT ship the sourcemap to prod.
export const CONFIG = {
  apiBase: "https://api.pagoscafe.online",
  settlement: {
    // internal-only mesh host (not routable from the edge)
    host: "http://settlement-internal:9090",
    rpc: "/rpc/transfer",
    // signed request: HMAC-SHA256 over the canonical string, hex
    canonical: "from|to|amount|ts",
    signSecret: "mag_live_sk_7c1f9a2e8d4b6003"
  }
};
